import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Servicio para manejar operaciones de Declaración de Renta
 * Encapsula las llamadas al API del módulo de declaración de renta (F-22)
 */
class DeclaracionRentaService {
    _getHeaders(token) {
        return {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }

    _getMultipartHeaders(token) {
        return {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        };
    }

    _handleError(error, defaultMessage) {
        if (error.response) {
            throw new Error(error.response.data.message || defaultMessage);
        } else if (error.request) {
            throw new Error('No se pudo conectar con el servidor');
        } else {
            throw new Error(error.message || defaultMessage);
        }
    }

    /**
     * Obtiene los datos guardados del F-22 para una empresa y año tributario.
     *
     * @param {number} anio - Año tributario (ej: 2025)
     * @param {number} id_company - ID de la empresa
     * @param {string} token - JWT de autenticación
     * @returns {Promise<Object>} - { success, data } donde data puede ser null si no existe
     */
    async obtenerDatosGuardados(anio, id_company, token) {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/api/declaracion-renta/datos-sii`,
                {
                    headers: this._getHeaders(token),
                    params: { anio, id_company }
                }
            );
            return response.data;
        } catch (error) {
            this._handleError(error, 'Error al obtener los datos de renta guardados');
        }
    }

    /**
     * Carga una Declaración de Renta F-22 desde un archivo PDF.
     * Claude extrae todos los códigos y los guarda en la tabla del año correspondiente.
     *
     * @param {File} pdfFile - Archivo PDF del F-22
     * @param {number} id_company - ID de la empresa
     * @param {string} token - JWT de autenticación
     * @returns {Promise<Object>} - { success, data, fieldsExtracted, fieldsMissing, anio_tributario, message }
     */
    async cargarDesdepdf(pdfFile, id_company, token) {
        try {
            const formData = new FormData();
            formData.append('pdf', pdfFile);
            formData.append('id_company', id_company);

            const response = await axios.post(
                `${API_BASE_URL}/api/declaracion-renta/cargar-pdf`,
                formData,
                { headers: this._getMultipartHeaders(token) }
            );

            return response.data;
        } catch (error) {
            this._handleError(error, 'Error al cargar la declaración de renta desde PDF');
        }
    }
}

const declaracionRentaService = new DeclaracionRentaService();
export default declaracionRentaService;
